import React, { Component } from 'react'
import menuMaster from '../../menu';
import MenuHeading from '../../components/Menu/MenuHeading';
import MenuLink from '../../components/Menu/MenuLink';
import MenuEnd from '../../components/Menu/MenuEnd';

class SiteMapCol extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: []
        }

        for (var i = 0; i < menuMaster.length; i++) {
            if (menuMaster[i].section.toUpperCase() === this.props.section.toUpperCase()) {
                this.state.options = menuMaster[i].menu
            }
        }
    }



    render() {
        var e = this;
        var options = this.state.options.map(function (item, index) {
            return (
                <div key={index}>
                    {
                        item.heading === true ?
                            <MenuHeading name={"menuFind_" + item.link} text={item.title} small={true} />
                            :
                            <MenuLink name={"menuFind_" + item.link} text={item.title} to={e.props.article === undefined ? (e.props.section + "/" + item.link) : (e.props.section + "/" + item.link)} small={true} />
                    }
                </div>
            );
        });

        return (
            <div className="siteMapCol">
                <div style={{ fontSize: 18, fontWeight: "bold" }}>{this.props.section}</div>
                {options}
                <MenuEnd />
            </div>
        );
    }
}

export default SiteMapCol


// WEBPACK FOOTER //
// ./src/components/Menu/SiteMapCol.js